import React, {Component} from 'react';
import {Button, Checkbox, Col, Row} from "react-bootstrap";

import "./style.css";

class BackgroundRemovalPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            enabled: true,
            crf: 0,
            matting: 0
        };
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    isValidInput = (inp, min, max) => {
        return true
        if (inp === "") return true;
        let val = parseFloat(inp);
        return (!isNaN(val) && val >= min && val <= max);
    };

    updateFields = function(value){
        var updates = {}
        for(var key in value){
            if(this.state[key] != undefined){
                updates[key] = value[key]
            }
        }

        this.setState(updates)
    }

    handleRangeOnChange = (event) => {
        var min = -100
        var max = 100
        if(event.target.name === 'vignette') {
            min = 0
        }

        if (this.isValidInput(event.target.value, min, max)) {
            this.set_state({[event.target.name]: event.target.value});
            // var value = {}
            // value[[event.target.name]] = Number(event.target.value);
            // this.props.apply_background_removal(value);
        }
    };

    handleCheckboxOnChange = () => {
        this.set_state({enabled: !this.state.enabled});
    };

    applyBgRemoval = (event) => {
        var min = -100
        var max = 100
        
        if (!this.isValidInput(this.state.crf, min, max)){
            return
        }

        if (!this.isValidInput(this.state.matting, min, max)){
            return
        }

        var value = {crf: this.state.crf,matting: this.state.matting, enabled: this.state.enabled }
        this.props.apply_background_removal(value);
    };

    render() {
        return (
            <div>
                <Row style={{marginBottom : 10}}>
                    <Col xs={12} style={{ display : 'table', 'marginBottom' : 10, paddingTop : 5 }}>
                    </Col>
                    <Col xs={3} className="adjustment-controls-text">
                        Enabled
                    </Col>
                    <Col xs={7} style={{paddingLeft:'40px',marginTop:'-15px'}}>
                        <Checkbox style={{zoom:2}} name={"enabled"} checked={this.state.enabled} onClick={this.handleCheckboxOnChange} inline></Checkbox>
                    </Col>
                    <Col xs={2}>
                    </Col>
                </Row>
                <Row style={{marginBottom : 10}}>
                    <Col xs={3} className="adjustment-controls-text">
                        CRF
                    </Col>
                    <Col xs={7}>
                        <input type="range" className="adjustment-slider" name="crf" min="-100" max="100" value={this.state.crf} onChange={(e) => this.handleRangeOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text" name="crf" onChange={(e) => this.handleRangeOnChange(e)} value={this.state.crf}/>
                    </Col>
                </Row>
                <Row style={{marginBottom : 10}}>
                    <Col xs={3} className="adjustment-controls-text">
                        Matting
                    </Col>
                    <Col xs={7}>
                        <input type="range" className="adjustment-slider" name="matting" min="-100" max="100" value={this.state.matting} onChange={(e) => this.handleRangeOnChange(e)}/>
                    </Col>
                    <Col className="filter-adjustment-col" xs={2}>
                        <input type="text" className="adjustment-input-text" name="matting" onChange={(e) => this.handleRangeOnChange(e)} value={this.state.matting}/>
                    </Col>
                </Row>
                <Row style={{marginBottom : 10}}>
                    <Col xs={12} className="">
                        <Button onClick={this.applyBgRemoval} className="btn btn-orange">Apply Changes</Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default BackgroundRemovalPanel;